import Vue from "vue";
export default Vue.extend({
    props: {
        info: {
            type: String,
            required: true,
        },
    },
});
